import { useQuery } from '@tanstack/react-query';
import { UserRole } from '@klaro7/shared-types';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { getTodayErrorCount } from '../services/error-log.service';

/**
 * Errori di oggi (giornata Europe/Rome) ancora NON gestiti, per il pallino ROSSO
 * sulla voce "Log Errori" in sidebar: niente errori aperti oggi → niente pallino.
 * La spunta "Gestito" sulla riga invalida ['error-logs'] e quindi scala subito il
 * contatore; "Visto" no, di proposito. Stesso pattern del badge antifrode
 * (staleTime 30s, refetch 60s). Endpoint super-admin only: per gli altri la query
 * non parte nemmeno.
 */
export function useTodayErrorsBadge(): number {
  const { hasRole } = useAuth();
  const enabled = hasRole(UserRole.SUPER_ADMIN);

  const { data } = useQuery({
    queryKey: ['error-logs', 'today-count'],
    queryFn: getTodayErrorCount,
    enabled,
    staleTime: 1000 * 30,
    refetchInterval: 1000 * 60,
    retry: false,
  });

  return enabled ? (data?.count ?? 0) : 0;
}
